import {
  GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID,
  GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS,
  HOSTED_PAGE_DO_PAYMENT,
  HOSTED_PAGE_DO_PAYMENT_SUCCESS,
  CHECK_BIN_CARD_NUMBER,
  CHECK_BIN_CARD_NUMBER_SUCCESS,
  CHECK_BIN_CARD_NUMBER_FAIL,
  HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR,
  HOSTED_PAYMENT_PAGE_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  record: {},
  checkBinCardRecord: {},
  checkBinError: null,
}


const hostedPaymentPage = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID:
      return {
        ...state,
        loading: true,
      }

    case GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        loading: false,
      }

    case HOSTED_PAGE_DO_PAYMENT:
      return {
        ...state,
        loading: true,
      }

    case HOSTED_PAGE_DO_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        record: action.payload,
      }

      case CHECK_BIN_CARD_NUMBER:
        return {
          ...state,
          checkBinLoading: true,
          checkBinError: null,
        }
  
      case CHECK_BIN_CARD_NUMBER_SUCCESS:
        return {
          ...state,
          checkBinLoading: false,
          checkBinCardRecord: action.payload,
          checkBinError: null,
        }

      case CHECK_BIN_CARD_NUMBER_FAIL:
        return {
          ...state,
          checkBinLoading: false,
          checkBinCardRecord: {},
          checkBinError: action.payload,
        }

      case HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR:
        return {
          ...state,
          checkBinError: null,
        }

    case HOSTED_PAYMENT_PAGE_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        checkBinLoading: false,
      }

    default:

      return state

  }
}

export default hostedPaymentPage